export const BORDER_RADIUS = '0';

export const H1_FONT_SIZE = '40px';
export const H2_FONT_SIZE = '32px';
export const H3_FONT_SIZE = '22px';
export const H4_FONT_SIZE = '18px';

export const HEADER_HEIGHT = '72px';
export const DESKTOP_NAVBAR_WIDTH = '250px';
